<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lvgqdx/tc-custom/9781636242699.jpg?1728851724769" alt="This image is the cover for the book War Along the Wabash"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">War Along the Wabash
      </h1>
      <p class="bookDescription body article font2">
        <p>Finalist, 2023 Army Historical Foundation Distinguished Writing Awards<br/><br/>On November 4, 1791, a coalition of warriors determined to set the Ohio River as a permanent boundary between tribal lands and white settlements faced an army led by Arthur St. Clair—the resulting horrific struggle ended in the greatest defeat of an American army at the hands of Native Americans.  The road to the battle of the Wabash began when Arthur St. Clair was appointed to lead an army into the heart of the Ohio Indian Confederacy while building a string of fortifications along the way. He would face difficulties in recruiting, training, feeding, and arming volunteer soldiers. From the moment St. Clair’s shattered force began its retreat from the Wabash the men blamed the officers, and the officers in turn blamed their men. For over two centuries most historians have blamed either the officer corps, enlisted soldiers, an entangled logistical supply line, poor communications, or equipment. The destruction of the army resulted in a stunned Congress authorizing a regular army in 1792.  This book, the result of 30 years’ research, puts the battle into the context of the last quarter of the 18th century, exploring how the central importance of land ownership to Europeans arriving in North America resulted in unrelenting demographic pressure on indigenous tribes, as well as the enormous obstacles standing in the way of the fledgling American Republic in paying off its enormous war debts.  This is the story of how a small band of determined indigenous peoples defended their homeland, destroyed an invading American army, and forced a fundamental shift in the way in which the United States waged war.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven P. Locke
      </h2>
      
      <p class="authorDescription body article">Steven P. Locke is a retired curator of history for the Ohio Historical Society. He served in the US Army National Guard, then taught history in the Granville, Ohio, Exempted School District. He studied at both undergraduate and graduate level at the Ohio State University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?423bff6d